import { render, staticRenderFns } from "./allData.vue?vue&type=template&id=20dd4a91&scoped=true&"
import script from "./allData.vue?vue&type=script&lang=js&"
export * from "./allData.vue?vue&type=script&lang=js&"
import style0 from "./allData.vue?vue&type=style&index=0&id=20dd4a91&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd4a91",
  null
  
)

export default component.exports